module.exports = __webpack_public_path__ + "static/img/yi.8e381d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/yi.jpg
// module id = 8iAH
// module chunks = 0